import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_CLASS_NAME = 'Table';

export const TABLE_CLASS_SLOTS = ['root', 'footer'] as const;

export type TableClassSlot = (typeof TABLE_CLASS_SLOTS)[number];

export interface TableClasses {
	root: string;
	isResizingColumn: string;
	footer: string;
}

export type TableClassKey = keyof TableClasses;

export const getTableUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_CLASS_NAME, slot);

export const tableClasses = generateUtilityClasses<keyof TableClasses>(
	TABLE_CLASS_NAME,
	['root', 'footer', 'isResizingColumn'],
);
export default tableClasses;
